// A camada impar fica 100 mm (ou o valor editado) atras da primeira.
// Centraliza a envolvente das duas camadas como um conjunto na largura.
export function centralizacaoConjuntoCem2x2(c, l, larguraPalete, sobreposicao, numCamadas) {
  const larguraCamada = Math.max(c, 2 * l);
  const larguraConjunto = larguraCamada + (numCamadas > 1 ? sobreposicao : 0);
  return Math.min(0, (larguraConjunto - larguraPalete) / 2);
}

export function posicaoZCamadaCem2x2(centralizacaoZ, sobreposicao, indiceCamada) {
  return centralizacaoZ - (indiceCamada % 2 === 1 ? sobreposicao : 0);
}
